import { Container } from "./container";

export { Container as Column };
